import { render } from "./LaborDashboard.vue?vue&type=template&id=5a9dced8"
import script from "./LaborDashboard.vue?vue&type=script&lang=js"
export * from "./LaborDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__